import { env } from '../config/env'

// The tenant is the leftmost label of the host. Server-side this read
// `req.headers.host`; there is no request here, so it is always the location.
export function getSubdomain(
  host: string = window.location.host,
  reviewTenant: string | undefined = env.reviewTenant
): string {
  // A review app is served at mr-<iid>.<review domain>, whose leftmost label is no tenant, so its build pins one instead.
  if (reviewTenant) {
    return reviewTenant
  }
  return host.split(':')[0].split('.')[0]
}
